export default {
  home_recent_site_event: '最近站点事件',
  home_recent_device_event: '最近设备事件',
  home_pie_total: '总数',
  home_pie_legend_enable: '启用站点',
  home_pie_legend_disable: '禁用站点',
  home_pie_alarm: '告警',
  home_pie_device: '设备',
  home_pie_model: '设备模型',
  home_pie_fault: '报错',
  home_pie_no_fault: '没有报错',
  home_pie_part_fault: '部分报错',
  home_pie_idle: '空闲',
  home_pie_restarting: '重启中',
  home_pie_updating: '更新中',
  home_pie_working: '运行中',

  // 站点
  home_pie_site_enabled: '启用站点',
  home_pie_site_disabled: '禁用站点',
  home_pie_device_alarm: '设备告警',
  home_pie_device_count: '设备数量',
  home_pie_device_model: '设备模型',

  // 故障
  home_fault_statistics: '故障统计',
  home_fault_ranking: '故障排行',

  // 单位
  home_device_units: '个',
  home_site_units: '个',
};
